import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.DateTime,
  title: 'Date Time',
  category: ComponentCategory.General,
};
